import IndividualContact from "../../../model/contact/IndividualContact";
import {ContactsMap} from "../../reducer/contact/ContactsState";

/**
 * Create individual contact successful action.
 */
export const INDIVIDUAL_CONTACT_CREATED = "INDIVIDUAL_CONTACT_CREATED";
export type INDIVIDUAL_CONTACT_CREATED = { contact: IndividualContact };

/**
 * Individual contacts fetched action.
 */
export const INDIVIDUAL_CONTACTS_FETCHED = "INDIVIDUAL_CONTACTS_FETCHED";
export type INDIVIDUAL_CONTACTS_FETCHED = { contacts: ContactsMap };


/**
 * Individual contact fetched action.
 */
export const INDIVIDUAL_CONTACT_FETCHED = "INDIVIDUAL_CONTACT_FETCHED";
export type INDIVIDUAL_CONTACT_FETCHED = { contact: IndividualContact };

/**
 * Edit individual contact successful action.
 */
export const INDIVIDUAL_CONTACT_EDITED = "INDIVIDUAL_CONTACT_EDITED";
export type INDIVIDUAL_CONTACT_EDITED = { contact: IndividualContact };

/**
 * Edit individual contact archive status successful action.
 */
export const INDIVIDUAL_CONTACT_ARCHIVE_STATUS_CHANGED = "INDIVIDUAL_CONTACT_ARCHIVE_STATUS_CHANGED";
export type INDIVIDUAL_CONTACT_ARCHIVE_STATUS_CHANGED = { contactId: string, archived: boolean };

/**
 * Individual contacts fetched action.
 */
export const APPOINTMENTS_INDIVIDUAL_CONTACTS_FETCHED = "APPOINTMENTS_INDIVIDUAL_CONTACTS_FETCHED";
export type APPOINTMENTS_INDIVIDUAL_CONTACTS_FETCHED = { contacts: ContactsMap };